import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-900/40">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            快速了解金沙娱乐，解答您的疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-900 rounded-xl border border-background-700/30 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 shrink-0 flex items-center justify-center transition-transform duration-200 ${openId === faq.id ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4 pt-0 animate-in fade-in slide-in-from-top-2 duration-200">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}